// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"f2539cde","78":"443fb6fb","735":"d1ef6488","742":"f9f2fad8","957":"963fe373"}[chunkId] + ".chunk.css";
};